<template>
<div class="categoryCatalog">
  <el-tabs type="border-card" class="tabs" tab-position="left">

    <el-tab-pane label="车—人" >
      <div class="mainTable" ref="date">
        <el-table  ref="multipleTable" tooltip-effect="dark" border highlight-current-row :data="Data.slice((pageInfo.currentPage-1)*pageInfo.pageSize,pageInfo.currentPage*pageInfo.pageSize)" :height="tableHeight" :max-height="tableHeight"
          :row-key="Data.id" v-loading="loading"  >
          <el-table-column v-for="(item,index) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
          </el-table-column>
          <el-table-column prop="image" align="center" label="示意图" width="200px">
            <!-- 图片的显示 -->
            <template slot-scope="scope">
              <!--<img :src="scope.row.image"  min-width="70" height="70" />-->
              <img :src="scope.row.url">
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="160" align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="display(name.two, scope.row)" type="primary">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="length.person" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 30]"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-tab-pane>
    <el-tab-pane label="车—车">
      <div class="mainTable" ref="date1">
        <el-table ref="multipleTable" tooltip-effect="dark" border highlight-current-row :data="CarData.slice((pageInfo.currentPage-1)*pageInfo.pageSize,pageInfo.currentPage*pageInfo.pageSize)" :height="tableHeight" :max-height="tableHeight"
          :row-key="Data.id" v-loading="loading" >
          <el-table-column v-for="(item,index) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
          </el-table-column>
          <el-table-column prop="image" align="center" label="示意图" width="200px">
            <!-- 图片的显示 -->
            <template slot-scope="scope">
              <!--<img :src="scope.row.image"  min-width="70" height="70" />-->
              <img :src="scope.row.url">
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="160" align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="display(name.there, scope.row)" type="primary">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="length.car" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 30]"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-tab-pane>
    <el-tab-pane label="车—二轮车">
      <div class="mainTable" ref="date2">
        <el-table ref="multipleTable" tooltip-effect="dark" border highlight-current-row :data="tableData.slice((pageInfo.currentPage-1)*pageInfo.pageSize,pageInfo.currentPage*pageInfo.pageSize)" :height="tableHeight" :max-height="tableHeight"
          :row-key="tableData.id" v-loading="loading">
          <el-table-column v-for="(item,index) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
          </el-table-column>
          <el-table-column type="index" prop="image" align="center" label="示意图" width="200px">
            <!-- 图片的显示 -->
            <template slot-scope="scope">
              <!--<img :src="scope.row.image"  min-width="70" height="70" />-->
              <img :src="scope.row.url">
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="160" align="center">
            <template slot-scope="scope">
              <el-button size="mini" slot="reference" @click="display(name.one, scope.row)" type="primary">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="length.carry" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 30]"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-tab-pane>
  </el-tabs>
  <kindCaseNumber></kindCaseNumber>
</div>
</template>

<script>
import bus from './bus'
import kindCaseNumber from "./kindCaseNumber";

export default {
  name: "场景分类目录",
  data() {
    return {
      /*加载动画*/
      loading: true,
      name: {
        one: '车—二轮车',
        two: '车—人',
        there: '车—车'
      },
      pageInfo: {
        currentPage: 1,
        pageSize: 10,
      },
      /*表格的最大高度*/
      tableHeight: '',
      /*表格组件渲染数组*/
      tableTitle: [{
          label: "序号",
          width: "90px",
          prop: "id",
          show: false
        },
        {
          label: "场景名称",
          width: "170px",
          prop: "name",
          show: false
        },
        {
          label: "中文描述",
          width: "220px",
          prop: "description",
          show: true
        },
        {
          label: "英文描述",
          width: "140px",
          prop: "EnglishDesc",
          show: true
        },
        {
          label: "数量",
          width: "100px",
          prop: "number",
          show: false
        },
      ],
      /*表格数据*/
      tableData: [
        {
          id: 1,
          name: 'SSTLS',
          description: '在普通路段，两车垂向行驶时，直行的汽车与直行的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Left on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 2,
          name: 'SSTRS',
          description: '在普通路段，两车垂向行驶时，直行的汽车与直行的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Right on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 3,
          name: 'LSTLS',
          description: '在普通路段，两车垂向行驶时，左转的汽车与直行的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Moving into the Left lane car to Straight Two wheelers from the Left on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 4,
          name: 'LSTRS',
          description: '在普通路段，两车垂向行驶时，左转的汽车与直行的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Moving into the Left lane car to Straight Two wheelers from the Right on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 5,
          name: 'RSTRS',
          description: '在普通路段，两车垂向行驶时，右转的汽车与直行的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Moving into the Right lane car to Straight Two wheelers from the Right on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 6,
          name: 'SLTLS',
          description: '在普通路段，两车垂向行驶时，直行的汽车与左转的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Left on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 7,
          name: 'SLTRS',
          description: '在普通路段，两车垂向行驶时，直行的汽车与左转的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Right on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 8,
          name: 'SSTLF',
          description: '在十字路口，两车垂向行驶时，直行的汽车与直行的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Left on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 9,
          name: 'SSTRF',
          description: '在十字路口，两车垂向行驶时，直行的汽车与直行的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Right on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 10,
          name: 'LSTLF',
          description: '在十字路口，两车垂向行驶时，左转的汽车与直行的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Two wheelers from the Left on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 11,
          name: 'LSTRF',
          description: '在十字路口，两车垂向行驶时，左转的汽车与直行的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Two wheelers from the Right on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 12,
          name: 'RSTLF',
          description: '在十字路口，两车垂向行驶时，右转的汽车与直行的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Right-turn car to Straight Two wheelers from the Left on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 13,
          name: 'SLTLF',
          description: '在十字路口，两车垂向行驶时，直行的汽车与左转的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Left on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 14,
          name: 'SLTRF',
          description: '在十字路口，两车垂向行驶时，直行的汽车与左转的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Right on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 15,
          name: 'SSTLT',
          description: '在丁字路口，两车垂向行驶时，直行的汽车与直行的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Left on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 16,
          name: 'SSTRT',
          description: '在丁字路口，两车垂向行驶时，直行的汽车与直行的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Right on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 17,
          name: 'LSTLT',
          description: '在丁字路口，两车垂向行驶时，左转的汽车与直行的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Two wheelers from the Left on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 18,
          name: 'LSTRT',
          description: '在丁字路口，两车垂向行驶时，左转的汽车与直行的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Two wheelers from the Right on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 19,
          name: 'RSTLT',
          description: '在丁字路口，两车垂向行驶时，右转的汽车与直行的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Right-turn car to Straight Two wheelers from the Left on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 20,
          name: 'RSTRT',
          description: '在丁字路口，两车垂向行驶时，右转的汽车与直行的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Right-turn car to Straight Two wheelers from the Right on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 21,
          name: 'SLTLT',
          description: '在丁字路口，两车垂向行驶时，直行的汽车与左转的二轮车（左方来车）发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Left on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 22,
          name: 'SLTRT',
          description: '在丁字路口，两车垂向行驶时，直行的汽车与左转的二轮车（右方来车）发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Right on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 23,
          name: 'SSTOS',
          description: '在普通路段，两车对向行驶时，直行的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Opposite direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 24,
          name: 'SLTOS',
          description: '在普通路段，两车对向行驶时，直行的汽车与左转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Opposite direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 25,
          name: 'SRTOS',
          description: '在普通路段，两车对向行驶时，直行的汽车与右转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Right-turn Two wheelers from the Opposite direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 26,
          name: 'LSTOS',
          description: '在普通路段，两车对向行驶时，左转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Moving into the Left lane car  to Straight Two wheelers from the Opposite direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 27,
          name: 'LLTOS',
          description: '在普通路段，两车对向行驶时，左转的汽车与左转的二轮车发生碰撞',
          EnglishDesc: 'Moving into the Left lane car to Left-turn Two wheelers from the Opposite direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 28,
          name: 'RSTOS',
          description: '在普通路段，两车对向行驶时，右转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Moving into the Right lane car  to Straight Two wheelers from the Opposite direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 29,
          name: 'SSTOF',
          description: '在十字路口，两车对向行驶时，直行的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Opposite direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 30,
          name: 'SLTOF',
          description: '在十字路口，两车对向行驶时，直行的汽车与左转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Opposite direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 31,
          name: 'SRTOF',
          description: '在十字路口，两车对向行驶时，直行的汽车与右转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Right-turn Two wheelers from the Opposite direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 32,
          name: 'LSTOF',
          description: '在十字路口，两车对向行驶时，左转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Two wheelers from the Opposite direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 33,
          name: 'LRTOF',
          description: '在十字路口，两车对向行驶时，左转的汽车与右转的二轮车发生碰撞',
          EnglishDesc: 'Left-turn car to Right-turn Two wheelers from the Opposite direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 34,
          name: 'RSTOF',
          description: '在十字路口，两车对向行驶时，右转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Right-turn car to Straight Two wheelers from the Opposite direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 35,
          name: 'SSTOT',
          description: '在丁字路口，两车对向行驶时，直行的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Opposite direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 36,
          name: 'SLTOT',
          description: '在丁字路口，两车对向行驶时，直行的汽车与左转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Opposite direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 37,
          name: 'SRTOT',
          description: '在丁字路口，两车对向行驶时，直行的汽车与右转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Right-turn Two wheelers from the Opposite direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 38,
          name: 'LSTOT',
          description: '在丁字路口，两车对向行驶时，左转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Two wheelers from the Opposite direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 39,
          name: 'RSTOT',
          description: '在丁字路口，两车对向行驶时，右转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Right-turn car to Straight Two wheelers from the Opposite direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 40,
          name: 'SSTSS',
          description: '在普通路段，两车同向行驶时，直行的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Same direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 41,
          name: 'SLTSS',
          description: '在普通路段，两车同向行驶时，直行的汽车与左转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Same direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 42,
          name: 'SRTSS',
          description: '在普通路段，两车同向行驶时，直行的汽车与右转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Right-turn Two wheelers from the Same direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 43,
          name: 'LSTSS',
          description: '在普通路段，两车同向行驶时，左转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Moving into the Left lane car to Straight Two wheelers from the Same direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 44,
          name: 'RSTSS',
          description: '在普通路段，两车同向行驶时，右转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Moving into the Right lane car to Straight Two wheelers from the Same direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 45,
          name: 'SSTSF',
          description: '在十字路口，两车同向行驶时，直行的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Same direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 46,
          name: 'SLTSF',
          description: '在十字路口，两车同向行驶时，直行的汽车与左转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Same direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 47,
          name: 'SRTSF',
          description: '在十字路口，两车同向行驶时，直行的汽车与右转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Right-turn Two wheelers from the Same direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 48,
          name: 'LSTSF',
          description: '在十字路口，两车同向行驶时，左转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Two wheelers from the Same direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 49,
          name: 'RSTSF',
          description: '在十字路口，两车同向行驶时，右转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Right-turn car to Straight Two wheelers from the Same direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 50,
          name: 'RRTSF',
          description: '在十字路口，两车同向行驶时，右转的汽车与右转的二轮车发生碰撞',
          EnglishDesc: 'Right-turn car to Right-turn Two wheelers from the Same direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 51,
          name: 'SSTST',
          description: '在丁字路口，两车同向行驶时，直行的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Straight Two wheelers from the Same direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 52,
          name: 'SLTST',
          description: '在丁字路口，两车同向行驶时，直行的汽车与左转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Two wheelers from the Same direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 53,
          name: 'SRTST',
          description: '在丁字路口，两车同向行驶时，直行的汽车与右转的二轮车发生碰撞',
          EnglishDesc: 'Straight car to Right-turn Two wheelers from the Same direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 54,
          name: 'LSTST',
          description: '在丁字路口，两车同向行驶时，左转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Two wheelers from the Same direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 55,
          name: 'RSTST',
          description: '在丁字路口，两车同向行驶时，右转的汽车与直行的二轮车发生碰撞',
          EnglishDesc: 'Right-turn car to Straight Two wheelers from the Same direction on the T-Junction',
          url: '',
          number: 0
        },
        {
          id: 56,
          name: 'RLTST',
          description: '在丁字路口，两车同向行驶时，右转的汽车与左转的二轮车发生碰撞',
          EnglishDesc: 'Right-turn car to Left-turn Two wheelers from the Same direction n the T-Junction',
          url: '',
          number: 0

        },

      ],
      Data: [
        {
          id: 1,
          name: 'LPLS',
          description: '车辆在普通路段左转，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Moving into the Left lane car to Pedestrian from Left on Straight road',
          url: '',
          number: 0
        },
        {
          id: 2,
          name: 'LPRS',
          description: '车辆在普通路段左转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Moving into the Left lane car to Pedestrian from Right on Straight road',
          url: '',
          number: 0
        },
        {
          id: 3,
          name: 'RPRS',
          description: '车辆在普通路段右转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Moving into the Right lane car to Pedestrian from Right on Straight road',
          url: '',
          number: 0
        },
        {
          id: 4,
          name: 'RPSS',
          description: '车辆在普通路段右转，与同向行走的行人发生碰撞',
          EnglishDesc: 'Moving into the Right lane car to Pedestrian in the Same direction on Straight road',
          url: '',
          number: 0
        },
        {
          id: 5,
          name: 'SPLS',
          description: '车辆在普通路段直行，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Left on Straight road',
          url: '',
          number: 0
        },
        {
          id: 6,
          name: 'SPRS',
          description: '车辆在普通路段直行，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Right on Straight road',
          url: '',
          number: 0
        },
        {
          id: 7,
          name: 'SPSS',
          description: '车辆在普通路段直行，与同向行走的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian in the Same direction on Straight road',
          url: '',
          number: 0
        },
        {
          id: 8,
          name: 'SPMS',
          description: '车辆在普通路段直行，与静止的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian  of Motionless on Straight road',
          url: '',
          number: 0
        },
        {
          id: 9,
          name: 'BPMS',
          description: '车辆在普通路段倒车，与静止的行人发生碰撞',
          EnglishDesc: 'Backward car to Pedestrian of Motionless on Straight road',
          url: '',
          number: 0
        },
        {
          id: 10,
          name: 'LPLCL',
          description: '车辆在左弯道路左转，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Left-turn car to Pedestrian from Left on Curve road to the Left',
          url: '',
          number: 0
        },
        {
          id: 11,
          name: 'LPRCL',
          description: '车辆在左弯道路左转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Left-turn car to Pedestrian from Right on Curve road to the Left',
          url: '',
          number: 0
        },
        {
          id: 12,
          name: 'LPMCL',
          description: '车辆在左弯道路左转，与静止的行人发生碰撞',
          EnglishDesc: 'Left-turn car to Pedestrian of Motionless on Curve road to the Left',
          url: '',
          number: 0
        },
        {
          id: 13,
          name: 'RPRCL',
          description: '车辆在左弯道路右转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Moving into the Right lane car to Pedestrian from Right on Curve road to the Left',
          url: '',
          number: 0
        },
        {
          id: 14,
          name: 'RPMCL',
          description: '车辆在左弯道路右转，与静止的行人发生碰撞',
          EnglishDesc: 'Moving into the Right lane car to Pedestrian of Motionless on Curve road to the Left',
          url: '',
          number: 0
        },
        {
          id: 15,
          name: 'SPLCL',
          description: '车辆在左弯道路直行，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Left on Curve road to the Left',
          url: '',
          number: 0
        },
        {
          id: 16,
          name: 'RPRCR',
          description: '车辆在右弯道路右转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Right-turn car to Pedestrian form Right on Curve road to the Right',
          url: '',
          number: 0
        },
        {
          id: 17,
          name: 'RPSCR',
          description: '车辆在右弯道路右转，与同向行走的行人发生碰撞',
          EnglishDesc: 'Right-turn car to Pedestrian in the Same direction on Curve road to the Right',
          url: '',
          number: 0
        },
        {
          id: 18,
          name: 'RPMCR',
          description: '车辆在右弯道路右转，与静止的行人发生碰撞',
          EnglishDesc: 'Right-turn car to Pedestrian of Motionless on Curve road to the Right',
          url: '',
          number: 0
        },
        {
          id: 19,
          name: 'LPLT',
          description: '车辆在T字路口左转，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Left-turn car to Pedestrian form Left on T-junction',
          url: '',
          number: 0
        },
        {
          id: 20,
          name: 'LPRT',
          description: '车辆在T字路口左转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Left-turn car to Pedestrian form Right on T-junction',
          url: '',
          number: 0
        },
        {
          id: 21,
          name: 'RPRT',
          description: '车辆在T字路口右转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Right-turn car to Pedestrian form Right on T-junction',
          url: '',
          number: 0
        },
        {
          id: 22,
          name: 'RPST',
          description: '车辆在T字路口右转，与同向行走行人发生碰撞',
          EnglishDesc: 'Right-turn car to Pedestrian in the Same direction on T-junction',
          url: '',
          number: 0
        },
        {
          id: 23,
          name: 'RPMT',
          description: '车辆在T字路口右转，与静止的行人发生碰撞',
          EnglishDesc: 'Right-turn car to Pedestrian of Motionless direction on T-junction',
          url: '',
          number: 0
        },
        {
          id: 24,
          name: 'SPLT',
          description: '车辆在T字路口直行，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian form Left on T-junction',
          url: '',
          number: 0
        },
        {
          id: 25,
          name: 'SPRT',
          description: '车辆在T字路口直行，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian form Right on T-junction',
          url: '',
          number: 0
        },
        {
          id: 26,
          name: 'SPMT',
          description: '车辆在T字路口直行，与静止的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian of Motionless on T-junction',
          url: '',
          number: 0
        },
        {
          id: 27,
          name: 'BPMT',
          description: '车辆在T字路口倒车，与静止的行人发生碰撞',
          EnglishDesc: 'Backward car to Pedestrian of Motionless on T-junction',
          url: '',
          number: 0
        },
        {
          id: 28,
          name: 'LPLF',
          description: '车辆在十字路口左转，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Left-turn car to Pedestrian from Left on Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 29,
          name: 'LPRF',
          description: '车辆在十字路口左转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Left-turn car to Pedestrian from Right on Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 30,
          name: 'RPRF',
          description: '车辆在十字路口右转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Right-turn car to Pedestrian from Right on Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 31,
          name: 'SPLF',
          description: '车辆在十字路口直行，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Left on Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 32,
          name: 'SPRF',
          description: '车辆在十字路口直行，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Right on Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 33,
          name: 'SPSF',
          description: '车辆在十字路口直行，与同向行走的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian in the Same direction on Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 34,
          name: 'SPMF',
          description: '车辆在十字路口直行，与静止的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian of Motionless on Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 35,
          name: 'RPLE',
          description: '车辆在路段进出口右转，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Right-turn car to Pedestrian from Left on Entrance/Exit lane road ',
          url: '',
          number: 0
        },
        {
          id: 36,
          name: 'SPLE',
          description: '车辆在路段进出口直行，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Left on Entrance/Exit lane road',
          url: '',
          number: 0
        },
        {
          id: 37,
          name: 'SPRE',
          description: '车辆在路段进出口直行，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Right on Entrance/Exit lane road',
          url: '',
          number: 0
        },
        {
          id: 38,
          name: 'SPME',
          description: '车辆在路段进出口直行，与从静止的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian of Motionless on Entrance/Exit lane road',
          url: '',
          number: 0
        },
        {
          id: 39,
          name: 'BPME',
          description: '车辆在路段进出口倒车，与从运动的行人发生碰撞',
          EnglishDesc: 'Backward Pedestrian of Motionless on Entrance/Exit lane road',
          url: '',
          number: 0
        },
        {
          id: 40,
          name: 'SPLU',
          description: '车辆在隧道内直行，与从隧道左侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Left in Underground tunnel',
          url: '',
          number: 0
        },
        {
          id: 41,
          name: 'SPRU',
          description: '车辆在隧道内直行，与从隧道右侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Right in Underground tunnel',
          url: '',
          number: 0
        },
        {
          id: 42,
          name: 'RPRR',
          description: '车辆在匝道口右转，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Right-turn car to Pedestrian from Right on Ramp',
          url: '',
          number: 0
        },
        {
          id: 43,
          name: 'SPRR',
          description: '车辆在匝道口直行，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Right on Ramp',
          url: '',
          number: 0
        },
        {
          id: 44,
          name: 'SPLSN',
          description: '车辆在变窄路段直行，与从道路左侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Left on Straight road to Narrow',
          url: '',
          number: 0
        },
        {
          id: 45,
          name: 'SPRSN',
          description: '车辆在变窄路段直行，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Right on Straight road to Narrow',
          url: '',
          number: 0
        },
        {
          id: 46,
          name: 'SPRSW',
          description: '车辆在变宽路段直行，与从道路右侧穿越的行人发生碰撞',
          EnglishDesc: 'Straight car to Pedestrian from Right on Straight road to Wide',
          url: '',
          number: 0
        },
      ],
      CarData: [
        {
          id: 1,
          name: 'SSASS',
          description: '车辆在普通路段直行，与同向直行的目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Straight Automobile of the Same direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 2,
          name: 'SSAOS',
          description: '车辆在普通路段直行，与对向直行的目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Straight Automobile from the Opposite direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 3,
          name: 'SSARF',
          description: '车辆在四枝分岔口直行，与右方直行目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Straight Automobile from Right on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 4,
          name: 'SSALF',
          description: '车辆在四枝分岔口直行，与左方直行目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Straight Automobile from Left on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 5,
          name: 'LSASF',
          description: '车辆在四枝分岔口左转，与对向直行目标车辆发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Automobile from the Opposite direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 6,
          name: 'SMASS',
          description: '车辆在普通路段直行，与同向停止目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Motionless Automobile of the Same direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 7,
          name: 'LSARF',
          description: '车辆在四枝分岔口左转，与右方直行目标车辆发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Automobile from Right on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 8,
          name: 'SLAOF',
          description: '车辆在四枝分岔口直行，与对向左转目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Automobile from the Opposite direction on the Four-legged',
          url: '',
          number: 0
        },
        {
          id: 9,
          name: 'SLALF',
          description: '车辆在四枝分岔口直行，与左方左转目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Automobile from the Left on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 10,
          name: 'SLARF',
          description: '车辆在四枝分岔口直行，与右方左转目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Automobile from Right on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 11,
          name: 'LSAOT',
          description: '车辆在三枝分岔口左转，与对向直行目标车辆发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Automobile from the Opposite direction on T-Junction',
          url: '',
          number: 0
        },
        {
          id: 12,
          name: 'RSASS',
          description: '车辆在普通路段向右变道，与同向直行目标车辆发生碰撞',
          EnglishDesc: 'Moving into the Right lane car to Straight Automobile of the Same direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 13,
          name: 'LSAOS',
          description: '车辆在普通路段向左变道，与对向直行目标车辆发生碰撞',
          EnglishDesc: 'Moving into the Left lane car to Straight Automobile from the Opposite direction on the Straight road',
          url: '',
          number: 0
        },
        {
          id: 14,
          name: 'LSALT',
          description: '车辆在三枝分岔口左转，与左方直行目标车辆发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Automobile from Left on T-Junction',
          url: '',
          number: 0
        },
        {
          id: 15,
          name: 'SLAOT',
          description: '车辆在三枝分岔口直行，与对向左转目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Automobile from the Opposite direction on T-Junction',
          url: '',
          number: 0
        },
        {
          id: 16,
          name: 'LSALF',
          description: '车辆在四枝分岔口左转，与左方直行目标车辆发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Automobile from Left on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 17,
          name: 'SSASF',
          description: '车辆在四枝分岔口直行，与同向直行目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Straight Automobile of the Same direction on the Four-legged crossroad',
          url: '',
          number: 0
        },
        {
          id: 18,
          name: 'SLART',
          description: '车辆在三枝分岔口直行，与右方左转目标车辆发生碰撞',
          EnglishDesc: 'Straight car to Left-turn Automobile from Right on T-Junction',
          url: '',
          number: 0
        },
        {
          id: 19,
          name: 'LSART',
          description: '车辆在三枝分岔口左转，与右方直行目标车辆发生碰撞',
          EnglishDesc: 'Left-turn car to Straight Automobile from Right on T-Junction',
          url: '',
          number: 0
        },
      ],
      length: {
        carry: 56,
        person: 46,
        car: 19,
      }
    }
  },
  components: {
    kindCaseNumber,
  },
  methods: {
    /* 分页大小切换*/
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
    },
    /*分页切换*/
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
    },
    display(name, row) {
      let classType = name;
      let className = row.name;
      this.loading = true;
      this.$http.get('/statistics/classify/content', {
        params: {
          classType,
          className
        }
      }).then((res) => {
        bus.$emit("kindNumber", res)
        this.$nextTick(
          this.loading = false,
        );
      }).catch((error) => {
        console.log(error);
        this.$nextTick(
          this.loading = false,
        );
      })
    },
    /*获取高度*/
    getHeight() {
      /*定义两个高度，初始高度和现在高度*/
      let nowH;
      /*延迟获取当前高度*/
      this.$nextTick(() => {
        nowH = this.$refs.date.offsetHeight - 36;
      });
      let height = this.tableHeight;
      /*比对操作*/
      if (nowH !== height) {
        this.tableHeight = nowH;
        this.table++;
      }
    },
  },
  mounted() {
    /*当真实DOM渲染完成后调用该钩子获取当前data元素的高度并保存*/
    /*在created调用会报bug因为页面初始化时vue生命周期中先虚拟DOM，此时真实的DOM还没有挂载，无法获取*/
    this.$nextTick(() => {
      this.tableHeight = this.$refs.date.offsetHeight - 36;
    });
    /*发请求人二轮车*/
    let classType = this.name.one;
    let className = '';
    let arr = [];
    /*
    /*   -------------------  */
    this.tableData.forEach((item, index) => {
      arr.push(new Promise((resolve, reject) => {
        className = item.name;
        this.loading = true;
        this.$http.get('/statistics/classify/count', {
          params: {
            classType,
            className
          }
        }).then((res)=>{
          this.tableData[index].url = res.url;
          this.tableData[index].number = res.number;
          resolve(res)
        })
      }))
      Promise.all(arr).then(value => {
        this.tableData.sort((a,b)=>{
          return b.number - a.number
        })
      }).catch((err)=>{
        console.log(err)
      })
    })
    /*发请求人车*/
    arr = [];
    classType = this.name.two;
    this.Data.forEach((item, index) => {
      arr.push(new Promise((resolve, reject) => {
        className = item.name;
        this.loading = true;
        this.$http.get('/statistics/classify/count', {
          params: {
            classType,
            className
          }
        }).then((res)=>{
          this.Data[index].url = res.url;
          this.Data[index].number = res.number;
          resolve(res)
        })
      }))
      Promise.all(arr).then(value => {
        let p = new Promise((resolve, reject) => {

          this.Data.sort((a,b)=>{
            return b.number - a.number
          })
          setTimeout(()=>{
            resolve('ok')
          },300)

        })
        p.then(()=>{
          this.loading = false
        })

      }).catch((err)=>{
        console.log(err);
      })
    })
    /*发请求车车*/
    arr =[]
    classType = this.name.there;
    this.CarData.forEach((item, index) => {
      arr.push(new Promise((resolve, reject) => {
        className = item.name;
        this.loading = true;
        this.$http.get('/statistics/classify/count', {
          params: {
            classType,
            className
          }
        }).then((res)=>{
          this.CarData[index].url = res.url;
          this.CarData[index].number = res.number;
          resolve(res)
        })
      }))
      Promise.all(arr).then(value => {
        this.CarData.sort((a,b)=>{
          return b.number - a.number
        })
      }).catch((err)=>{
        console.log(err)
      })
    })
  },
  created() {
    /*在页面初始化时调用获取实时高度函数*/
    this.getHeight();

  },
}
</script>

<style scoped>
.categoryCatalog {
  width: 100%;
  height: calc(100% - 34px);
}

.categoryCatalog .el-tab-pane {
  width: 100%;
  height: 100%;
}

.categoryCatalog .tabs {
  width: 100%;
  height: 100%;
  border: none;
}

/*展示框样式*/
.categoryCatalog .mainTable {
  width: 100%;
  height: 100%;
}
</style>
<style>
.categoryCatalog .el-tabs__content {
  height: 100%;
  width: 100%;
  padding: 0 !important;
}

.categoryCatalog .el-pagination {
  text-align: center;
}

.categoryCatalog .mainTable .el-table,
.categoryCatalog .mainTable .cell {
  white-space: normal !important;
}

.categoryCatalog .cell>.el-button {
  width: 80px;
  min-width: 80px;
}

.categoryCatalog .cell img {
  width: 150px;
  height: 100px;
}

.inner {
  width: 100%;
  height: 50px;
}

.inner table tr {
  height: 25px;
}

.inner table tr td {
  width: 1%;
}

.categoryCatalog .el-tabs--left .el-tabs__item.is-left {
  text-align: center;
  color: black;
  font-size: 16px;
}

.categoryCatalog .el-tabs {
  display: flex !important;
}
</style>



// WEBPACK FOOTER //
// src/statistics/categoryCatalog.vue